var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentDate)?_c('div',{staticClass:"c-dashboard__wrap",attrs:{"data-component-name":_vm.$options.name}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }